import { MessageStroke16 } from '@cian/ui-kit/icons';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackChatsIconClick } from './tracking';
import { Utility } from '../../components/Utility';
import { IApplicationState } from '../../types/redux';

export const UtilityMessagesContainer: React.FC = () => {
  const messagesLink = useSelector<IApplicationState, string>(state => state.servicesLinks.messages);
  const messagesCount = useSelector<IApplicationState, number>(state => state.messages.count);

  return (
    <Utility
      title="Сообщения"
      unread={Boolean(messagesCount)}
      onClick={trackChatsIconClick}
      icon={MessageStroke16}
      href={messagesLink}
    />
  );
};
